import React, { useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import api from '../../functions/api';
import { useToast } from '../ToastProvider';
import { ReactComponent as IconClose } from "../../assets/icons/icon-close.svg";

const DeleteUserConfirm = ({ data, show, handleClose, onDeleted }) => {
  const { showSuccess, showError } = useToast();
  const [loading, setLoading] = useState(false);

  if (!data) return null;               // nada que mostrar

  const handleDelete = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('access_token');
      await api.delete(`/auth/users/${data.id_user}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      showSuccess('Usuario eliminado');
      onDeleted?.(data.id_user);
      handleClose();
    } catch (err) {
      console.error(err);
      showError('No se pudo eliminar el usuario');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered dialogClassName="basic-modal">
      <Modal.Header closeButton={false}>
        <Modal.Title>Eliminar Usuario</Modal.Title>
        <button
          type="button"
          onClick={handleClose}
          aria-label="Cerrar modal"
          className="btn-reset ms-auto"   // define estilo a tu gusto
        >
          <IconClose className="mc-link__icon secondary" />
        </button>
      </Modal.Header>

      <Modal.Body className="text-center">
        <p className="confirm-text">
          ¿Seguro que deseas eliminar?
        </p>
      </Modal.Body>

      <Modal.Footer className="delete-confirm-btns">
        <Button
          onClick={handleDelete}
          disabled={loading}
          className="btn-pill btn-affirm"
        >
          {loading ? <Spinner size="sm" /> : 'Si'}
        </Button>

        <Button
          onClick={handleClose}
          className="btn-pill btn-cancel"
          variant="light"
        >
          No
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteUserConfirm;
